import {gsap} from "gsap/all";
import {BaseGameMars} from "../base/BaseGameMars";
import {Rover} from "./Rover";
import {Game} from "./Game";

// Constructor
export class BuildYourRoverRenderer extends BaseGameMars {

  constructor() {
    super(`data/build-your-rover.json`, 'build-your-rover-secondary');
    this.isReady = false;
    gsap.registerPlugin();
  }

  initGame() {

    super.initGame();

    // Build game object to use getAllConfigCodes()
    this.game = new Game(this);

    // Reusable rover instace
    this.rover = new Rover(app, "renderer", $("#rover .rover-preview"));

    // Disable color transitions
    gsap.set(this.rover.$container, {'--color-transition': "none"});

    this.isReady = true;

  }

  onScreenBridgeMessage(messageString) {
    this.loadRover(messageString);
  }

  getAllConfigCodes() {

    // Return all codes
    // return this.game.getAllConfigCodes(false);

    // Return only colorless codes
    return this.game.getAllConfigCodes(false, [{
      "id": "6",
      "hex": "#FFFFFF",
      "default": true
    }]);
  }

  loadRover(code) {
    console.log(`Loading Rover for ${code}`);

    // Even if we clone, we still need to check if the img are ready
    const images = this.rover.$container.find("img").toArray();
    const imagePromises = images.map(img => {
      if (img.complete) return Promise.resolve();
      return new Promise(resolve => {
        $(img).one("load error", resolve);
      });
    });

    // Once all images are loaded, apply config and reveal the rover
   return Promise.all(imagePromises).then(() => {
      requestAnimationFrame(() => {
        this.rover.applyConfig(code);

        gsap.set(this.rover.$container, {
          autoAlpha: 1,
          x: 10,
          y: 540 - this.rover.$container.outerHeight()
        });
      });
    })
  }

  /**
   * Reset function, used to go back clean version of the game
   * @param screenId
   */
  reset(screenId) {

    // Reset variable and timeline
    this.killTimeline(this.currentTimeline);
    this.killTimeline(this.timeline);

    const resetCallback = () => {
      // TODO Things that reset AFTER goToScreen

      // Kill animations, and remove rovers
      Object.values(this.rovers).forEach(rover => {
        gsap.killTweensOf(rover.$container.find("*"));
        gsap.killTweensOf(rover.$container);
      });
      this.$roverContainer.empty();
      this.rovers = {};

      this.game.reset();
    }

    // Super
    return super.reset(screenId, resetCallback);
  }

}
